import { VPS_CUST_DASHBOARD } from './TS_Dashboard'

/*
EXPORTING THE MODULES THAT WILL BE CONSUMED FROM THE OUTSIDE. 
*/

export {
    VPS_CUST_DASHBOARD
}



// WEBPACK FOOTER //
// ./js/App.ts